import { render, staticRenderFns } from "./ArchiveInfoModal.vue?vue&type=template&id=28f37fc4&scoped=true&"
import script from "./ArchiveInfoModal.vue?vue&type=script&lang=ts&"
export * from "./ArchiveInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveInfoModal.vue?vue&type=style&index=0&id=28f37fc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f37fc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VExpansionPanels,VIcon,VSpacer,VTooltip})
